import { EntidadeBase } from 'hay-core-react';
class PermissaoModel extends EntidadeBase {
    constructor() {
        super('permissao');
    }
}

const instance = new PermissaoModel();
export default instance;
